/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SetupTaskAssignee = {
  /**
   * Assignee email address.
   */
  email: string;
  /**
   * Resolved member display name.
   */
  name?: string | undefined;
  /**
   * Resolved member photo URL.
   */
  photoUrl?: string | undefined;
  /**
   * Resolved active organization member ID.
   */
  userId?: string | undefined;
};

/** @internal */
export const SetupTaskAssignee$inboundSchema: z.ZodMiniType<
  SetupTaskAssignee,
  unknown
> = z.pipe(
  z.object({
    email: z.string(),
    name: z.optional(z.string()),
    photo_url: z.optional(z.string()),
    user_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "photo_url": "photoUrl",
      "user_id": "userId",
    });
  }),
);

export function setupTaskAssigneeFromJSON(
  jsonString: string,
): SafeParseResult<SetupTaskAssignee, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SetupTaskAssignee$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SetupTaskAssignee' from JSON`,
  );
}
